function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "grabHandle"
}, React.createElement("circle", {
  cx: 10.5,
  cy: 1.5,
  r: 1.5
}), React.createElement("circle", {
  cx: 1.5,
  cy: 1.5,
  r: 1.5
}), React.createElement("circle", {
  cx: 10.5,
  cy: 9.5,
  r: 1.5
}), React.createElement("circle", {
  cx: 1.5,
  cy: 9.5,
  r: 1.5
}), React.createElement("circle", {
  cx: 10.5,
  cy: 17.5,
  r: 1.5
}), React.createElement("circle", {
  cx: 1.5,
  cy: 17.5,
  r: 1.5
}));

var SvgGrabHandle = function SvgGrabHandle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "12px",
    height: "20px",
    viewBox: "0 0 12 19",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGrabHandle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/GrabHandle.0b4df4b5.svg";
export { ForwardRef as ReactComponent };